<template>
	<tr>
		<td>
			<b-link
				href="#"
				@click.prevent="onUpdateClick"
			>{{ user.FirstName }} {{ user.LastName }}</b-link>
		</td>
		<td>{{ user.Email }}</td>
		<td>{{ user.PhoneNumber }}</td>
	</tr>
</template>
<script>
export default {
	name: "UserListRow",

	props: ["user"],

	methods: {
		onUpdateClick() {
			this.$emit("update", this.user.Id);
		},

		formatDate(date) {
			return dateFuncs.backEndDateFormat(date);
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/account/user-list-row.vue